class SimplyInPlaceMotion {
  constructor(root) {
    this.root = root;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.targets = [];
    this.observer = null;
  }

  init() {
    if (this.reduceMotion) return;

    const groups = [
      '.vw-hero__copy > *',
      '.vw-hero__visual',
      '.vw-trust-strip__grid > div',
      '.vw-section-heading',
      '.vw-split > *',
      '.vw-card',
      '.vw-gallery__item',
      '.vw-steps li',
      '.vw-included__panel',
      '.vw-specs',
      '.vw-faq__grid > *',
      '.vw-accordion details',
      '.vw-final-cta__inner > *'
    ];

    groups.forEach((selector) => {
      this.root.querySelectorAll(selector).forEach((element, index) => {
        if (element.hasAttribute('data-vw-reveal')) return;
        element.setAttribute('data-vw-reveal', selector.includes('gallery') || selector.includes('visual') ? 'scale' : 'rise');
        element.style.setProperty('--vw-reveal-delay', `${Math.min(index % 4, 3) * 90}ms`);
        this.targets.push(element);
      });
    });

    this.root.classList.add('vw-motion-ready');

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        this.observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    this.targets.forEach((target) => this.observer.observe(target));
  }
}

const initSimplyInPlaceMotion = () => {
  document.querySelectorAll('.vw-store').forEach((root) => {
    if (root.dataset.motionInitialized === 'true') return;
    root.dataset.motionInitialized = 'true';
    new SimplyInPlaceMotion(root).init();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSimplyInPlaceMotion, { once: true });
} else {
  initSimplyInPlaceMotion();
}

document.addEventListener('shopify:section:load', initSimplyInPlaceMotion);
